import { render, staticRenderFns } from "./PzYousign.vue?vue&type=template&id=0b07fec8"
import script from "./PzYousign.vue?vue&type=script&lang=js"
export * from "./PzYousign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b07fec8')) {
      api.createRecord('0b07fec8', component.options)
    } else {
      api.reload('0b07fec8', component.options)
    }
    module.hot.accept("./PzYousign.vue?vue&type=template&id=0b07fec8", function () {
      api.rerender('0b07fec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Yousign/PzYousign.vue"
export default component.exports